import { Tenant } from "./tenant"

export type PlaceDetail = {
    geometry: {
        location: {
            lat(): number
            lng(): number
        }
    }
    name: string
    utc_offset_minutes: number
}

export type LocationApiItem = {
    disabled: boolean
    id: string
    name: string
    city: string
    country: string
    state: string
    phone: string
    timezone: string
    zip: string
    online?: boolean
    deletedAt?: string
    tenant: Tenant
    imageUrl?: string
    latitude?: number
    longitude?: number
    manager: Record<string, string>
    locationSpaces: LocationSpaceApiItem[]
    streetAddress1: string
    streetAddress2: string
    url?: string
    notes?: string
}

export interface LocationItem {
    id: string
    disabled: boolean
    street_1: string
    street_2: string
    city: string
    zip: string
    state: string
    country: string
    name: string
    online: boolean
    phone: string
    image_url: string
    timezone: string
    location_spaces?: LocationSpace[]
    is_archived?: boolean
    notes?: string
    manager: Record<string, string>
}

export function mapLocationFromDTO(location: LocationApiItem): LocationItem{
    return ({
        id: location.id,
        disabled: location.disabled,
        street_1: location.streetAddress1,
        street_2: location.streetAddress2,
        city: location.city,
        zip: location.zip,
        state: location.state,
        country: location.country,
        name: location.name,
        online: !!location.online,
        phone: location.phone,
        image_url: location.imageUrl || "",
        timezone: location.timezone,
        location_spaces: normalizeLocationSpaceApiItem(location.locationSpaces),
        is_archived: !!location.deletedAt,
        notes: location.notes,
        manager: location.manager
    })
}

export interface LocationSpaceApiItem {
    createdAt: string
    id: string
    locationId: string
    maxCapacity: number
    name: string
    updatedAt: string
}

export interface LocationSpace {
    created_at: string
    id: string
    location_id: string
    max_capacity: number
    name: string
    updated_at: string
}

export function mapLocationSpaceToRecord(
    locationSpaceArray: LocationSpaceApiItem[]
) {
    const location_space_record: Record<string, string>[] =
        locationSpaceArray.map((ls) => {
            return {
                id: ls.id,
                name: ls.name,
            }
        })

    return location_space_record
}

export function normalizeLocationSpaceApiItem(
    locationSpaces: LocationSpaceApiItem[]
) {
    return locationSpaces?.map((ls) => {
        return {
            created_at: ls.createdAt,
            id: ls.id,
            location_id: ls.locationId,
            max_capacity: ls.maxCapacity,
            name: ls.name,
            updated_at: ls.updatedAt,
        } as LocationSpace
    })
}
